import React from "react";
import AdminDashboard from "../components/AdminDashboard";

function Dashboard() {
  return <AdminDashboard />;
}

export default Dashboard;
